<template>
  <div class="file-input-container">
    <!-- Label -->
    <label class="w-full text-left font-weight-black mb-2">
      {{ label }}
      <span v-if="required" class="red--text">*</span>
    </label>

    <!-- Button -->
    <button
      type="button"
      class="custom-button font-weight-bold"
      @click="triggerInput"
    >
      {{ buttonText }}
    </button>

    <!-- Hidden input -->
    <input
      v-if="!hideReset"
      ref="fileInput"
      type="file"
      :accept="accept"
      style="display: none"
      @change="onSelectFile"
    />

    <!-- File name -->
    <span class="ml-2 font-weight-black">
      {{ fileName }}
    </span>

    <!-- Error -->
    <div v-if="error" class="red--text text-caption mt-1">
      {{ error }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FileInput',
    props: {
      value: {
        type: File,
        default: null,
      },
      label: {
        type: String,
        required: true,
      },
      accept: {
        type: String,
        default: '',
      },
      maxSizeMb: {
        type: Number,
        default: null,
      },
      buttonText: {
        type: String,
        default: 'Seleccionar archivo',
      },
      placeholder: {
        type: String,
        default: 'Sin selección',
      },
      hideReset: Boolean,
      required: Boolean,
    },

    data() {
      return {
        error: null,
      };
    },

    computed: {
      fileName() {
        return this.value ? this.value.name : this.placeholder;
      },
    },

    watch: {
      value() {
        this.error = null;
      },
    },

    methods: {
      triggerInput() {
        this.$refs.fileInput.click();
      },

      onSelectFile(event) {
        const file = event.target.files[0];
        this.error = null;

        if (!file) {
          this.$emit('input', null);
          return;
        }

        if (this.required && !file) {
          this.error = 'Este campo es obligatorio';
          return;
        }

        if (this.maxSizeMb && file.size > this.maxSizeMb * 1024 * 1024) {
          this.error = `El archivo no debe superar ${this.maxSizeMb} MB`;
          return;
        }

        this.$emit('input', file);
        this.$emit('change', file);
      },

      validate() {
        if (this.required && !this.value) {
          this.error = 'Este campo es obligatorio';
          return false;
        }
        this.error = null;
        return true;
      },
    },
  };
</script>

<style scoped>
  .file-input-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .custom-button {
    background: #f1edec 0% 0% no-repeat padding-box;
    box-shadow: inset 0px 3px 6px #00000029, 0px 3px 6px #00000029;
    border: 1px solid #707070;
    opacity: 1;
    padding-left: 3em;
    padding-right: 3em;
  }
</style>
